'use client';

import type { ReactNode } from 'react';
import { HStack, VStack } from '@terra/ui-styled-system';
import { HeadingSection } from '../../components/typography';

export type ObjectEditSectionProps = {
  title: ReactNode;
  titleAddon?: ReactNode;
  children: ReactNode;
};

export function ObjectEditSection({
  title,
  titleAddon,
  children,
}: ObjectEditSectionProps) {
  return (
    <VStack gap={2} w="full" minW={0} alignItems="stretch">
      <HStack
        w="full"
        minW={0}
        justifyContent="space-between"
        alignItems="center"
        gap={4}
      >
        <HeadingSection color="fg.default">{title}</HeadingSection>
        {titleAddon}
      </HStack>
      {children}
    </VStack>
  );
}
